import styled from "styled-components/macro";

export const Root = styled.div`
  position: relative;
`;

export const ArrowButton = styled.button`
  border: none;
  background: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;

  svg {
    width: 20px;
    height: auto;

    path {
      fill: white;
    }
  }
`;

export const LeftArrowButton = styled(ArrowButton)`
  left: 0;
`;
export const RightArrowButton = styled(ArrowButton)`
  right: 0;
`;

export const Image = styled.img`
  width: 100%;
  height: 154px;
  object-fit: cover;
  border-radius: 8px;
`;
